/**
 * Maintenance mode: injects banner and optional storefront restrictions.
 * Configuration is read from #bwec-maintenance-config (JSON), populated from theme settings.
 */
(function () {
    'use strict';
  
    var CONFIG_ID = 'bwec-maintenance-config';
    var BANNER_ID = 'bwec-maintenance-banner';
  
    function readConfig() {
      var el = document.getElementById(CONFIG_ID);
      if (!el || !el.textContent) return null;
      try {
        return JSON.parse(el.textContent.trim());
      } catch (e) {
        return null;
      }
    }
  
    function parseInstant(iso) {
      if (!iso || typeof iso !== 'string' || !iso.trim()) return null;
      var t = Date.parse(iso.trim());
      return Number.isNaN(t) ? null : t;
    }
  
    function isWithinSchedule(cfg) {
      if (!cfg.useSchedule) return true;
      var now = Date.now();
      var start = parseInstant(cfg.startIso);
      var end = parseInstant(cfg.endIso);
      if (start !== null && now < start) return false;
      if (end !== null && now > end) return false;
      return true;
    }
  
    function isExperienceActive(cfg) {
      if (!cfg || !cfg.enabled) return false;
      return isWithinSchedule(cfg);
    }
  
    function insertBanner(cfg) {
      if (document.getElementById(BANNER_ID)) return;
  
      var announcementNodes = document.querySelectorAll('[data-section-type="announcement"]');
      var announcement =
        announcementNodes.length > 0 ? announcementNodes[announcementNodes.length - 1] : null;
      var el = document.createElement('div');
      el.id = BANNER_ID;
      el.className = 'bwec-maintenance-banner';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'polite');
      el.style.backgroundColor = cfg.bgColor || '#ff0000';
      el.style.color = cfg.textColor || '#ffffff';
  
      var inner = document.createElement('div');
      inner.className = 'bwec-maintenance-banner__inner';
      var p = document.createElement('p');
      p.className = 'bwec-maintenance-banner__text';
      p.textContent = cfg.message || '';
      inner.appendChild(p);
      el.appendChild(inner);
  
      if (announcement && announcement.parentNode) {
        announcement.insertAdjacentElement('afterend', el);
      } else {
        var skip = document.querySelector('.skip-link');
        if (skip && skip.parentNode) {
          skip.insertAdjacentElement('afterend', el);
        } else {
          document.body.insertBefore(el, document.body.firstChild);
        }
      }
  
      document.documentElement.classList.add('bwec-maintenance--active');
    }
  
    function normalizeCartPath(cartUrl) {
      if (!cartUrl || typeof cartUrl !== 'string') return '/cart';
      try {
        var u = new URL(cartUrl, window.location.origin);
        return u.pathname.replace(/\/$/, '') || '/cart';
      } catch (e) {
        return cartUrl.split('?')[0].replace(/\/$/, '') || '/cart';
      }
    }
  
    function pathIsCart(pathname, cartPath) {
      if (!pathname) return false;
      var p = pathname.replace(/\/$/, '') || '/';
      var c = cartPath.replace(/\/$/, '') || '/cart';
      return p === c || p.indexOf(c + '/') === 0;
    }
  
    function hrefTargetsCheckout(href) {
      if (!href) return false;
      try {
        var u = new URL(href, window.location.origin);
        return u.pathname.indexOf('/checkout') !== -1 || u.pathname.indexOf('/checkouts') !== -1;
      } catch (e) {
        return /\/checkout|\/checkouts/.test(href);
      }
    }
  
    function notifyBlocked(message) {
      if (message) {
        window.alert(message);
      }
      try {
        document.dispatchEvent(
          new CustomEvent('bwec:maintenance:blocked', {
            bubbles: true,
            detail: { message: message },
          })
        );
      } catch (e) {}
    }
  
    function matchesAddToCart(target) {
      if (!target || !target.closest) return false;
      var el = target.closest(
        [
          '[data-add-to-cart]',
          '[data-quick-add-to-cart]',
          '[data-bundle-custom-add-to-cart]',
          'form[action*="/cart/add"]',
          'button[name="add"]',
        ].join(', ')
      );
      if (el) return true;
      var btn = target.closest('button.btn--add-to-cart, .btn--add-to-cart');
      return !!btn;
    }
  
    function matchesCheckout(target) {
      var el = target.closest(
        'a[href*="/checkout"], a[href*="/checkouts"], button[name="checkout"], input[name="checkout"]'
      );
      if (!el) return false;
      if (el.tagName === 'A') {
        return hrefTargetsCheckout(el.getAttribute('href'));
      }
      return true;
    }
  
    function matchesCartInteraction(target, cartPath) {
      if (target.closest('[data-drawer-toggle="drawer-cart"]')) return true;
      var a = target.closest('a[href]');
      if (!a) return false;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/cart/add') !== -1) return false;
      try {
        var u = new URL(href, window.location.origin);
        if (pathIsCart(u.pathname, cartPath)) return true;
      } catch (e) {
        if (href.indexOf('/cart') !== -1 && href.indexOf('/cart/add') === -1) return true;
      }
      return false;
    }
  
    function matchesExtraSelectors(target, selectors) {
      if (!selectors || !selectors.length) return false;
      for (var i = 0; i < selectors.length; i++) {
        try {
          if (selectors[i] && target.closest(selectors[i])) return true;
        } catch (e) {}
      }
      return false;
    }
  
    function shouldBlockClick(event, cfg) {
      var cartPath = normalizeCartPath(cfg.cartUrl);
      if (cfg.blockAddToCart && matchesAddToCart(event.target)) return 'add_to_cart';
      if (cfg.blockCheckout && matchesCheckout(event.target)) return 'checkout';
      if (cfg.blockCartInteractions && matchesCartInteraction(event.target, cartPath)) {
        return 'cart';
      }
      if (matchesExtraSelectors(event.target, cfg.extraSelectors)) return 'custom';
      return null;
    }
  
    function shouldBlockSubmit(event, cfg) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return null;
      var action = form.getAttribute('action') || '';
      if (cfg.blockAddToCart && action.indexOf('/cart/add') !== -1) return 'add_to_cart';
      return null;
    }
  
    function patchFetch(cfg) {
      if (!cfg.blockAddToCart || !window.fetch) return;
      var original = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && url.indexOf('/cart/add') !== -1) {
          notifyBlocked(cfg.feedbackMessage);
          return Promise.reject(new Error('BWEC_MAINTENANCE'));
        }
        return original.apply(this, arguments);
      };
    }
  
    function attachRestrictions(cfg) {
      if (!cfg.applyRestrictions) return;
  
      var feedback = cfg.feedbackMessage || '';
  
      document.documentElement.classList.add('bwec-maintenance--restricted');
  
      document.addEventListener(
        'click',
        function (e) {
          var reason = shouldBlockClick(e, cfg);
          if (!reason) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          notifyBlocked(feedback);
        },
        true
      );
  
      document.addEventListener(
        'submit',
        function (e) {
          var r = shouldBlockSubmit(e, cfg);
          if (!r) return;
          e.preventDefault();
          e.stopPropagation();
          notifyBlocked(feedback);
        },
        true
      );
  
      patchFetch(cfg);
  
      if (cfg.blockAddToCart && window.jQuery) {
        window.jQuery(document).ajaxSend(function (_event, jqXHR, settings) {
          var url = settings.url || '';
          if (url.indexOf('/cart/add') !== -1) {
            jqXHR.abort();
            notifyBlocked(feedback);
          }
        });
      }
    }
  
    function main() {
      var raw = readConfig();
      if (!raw) return;
  
      var extra = [];
      if (raw.extraSelectorsRaw && typeof raw.extraSelectorsRaw === 'string') {
        raw.extraSelectorsRaw.split(',').forEach(function (s) {
          var t = s.trim();
          if (t) extra.push(t);
        });
      }
  
      var cfg = {
        enabled: !!raw.enabled,
        message: raw.message || '',
        bgColor: raw.bgColor || '#ff0000',
        textColor: raw.textColor || '#ffffff',
        useSchedule: !!raw.useSchedule,
        startIso: raw.startIso || '',
        endIso: raw.endIso || '',
        blockAddToCart: !!raw.blockAddToCart,
        blockCheckout: !!raw.blockCheckout,
        blockCartInteractions: !!raw.blockCartInteractions,
        extraSelectors: extra,
        extraSelectorsRaw: raw.extraSelectorsRaw,
        feedbackMessage: raw.feedbackMessage || '',
        cartUrl: raw.cartUrl || '/cart',
        applyRestrictions: raw.applyRestrictions !== false,
      };
  
      if (!isExperienceActive(cfg)) return;
  
      insertBanner(cfg);
  
      var anyBlock =
        cfg.blockAddToCart ||
        cfg.blockCheckout ||
        cfg.blockCartInteractions ||
        (cfg.extraSelectors && cfg.extraSelectors.length);
      if (anyBlock) {
        attachRestrictions(cfg);
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();